import React, { useState } from "react";
import DeleteUserModal from "../../../components/modals/DeleteUserModal";

const StudentTable = ({ students, deleteStudent }) => {
  const [isDeleteModalOpened, setDeleteModalOpened] = useState(false);

  const [studentForDeletion, setStudentForDeletion] = useState({});

  const handleStudentDeletionBtn = (student) => {
    setStudentForDeletion(student);
    setDeleteModalOpened(true);
  };

  const handleStudentDeleteModalBtn = (event) => {
    if (Object.keys(studentForDeletion).length !== 0) {
      deleteStudent(event, studentForDeletion.username, setDeleteModalOpened);
    }
  };

  return (
    <>
      <div className="w-[75%] overflow-x-auto shadow-md sm:rounded-lg mt-12 self-center">
        <table className="w-full text-xl text-left text-gray-500 dark:text-gray-400">
          <thead className="text-xl bg-[#474554] text-white uppercase">
            <tr>
              <th scope="col" className="px-6 py-3">
                GR No
              </th>
              <th scope="col" className="px-6 py-3">
                Student Name
              </th>
              <th scope="col" className="px-6 py-3">
                Email ID
              </th>
              <th scope="col" className="px-6 py-3">
                Department
              </th>
              <th scope="col" className="px-6 py-3">
                <span>Action</span>
              </th>
            </tr>
          </thead>
          <tbody>
            {students.map((student) => (
              <tr
                key={student.username}
                className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-[#333333] whitespace-nowrap"
                >
                  {student.username}
                </th>
                <td className="px-6 py-4 text-[#333333]">{student.name}</td>
                <td className="px-6 py-4 text-[#333333]">
                  {student.collegeEmailId}
                </td>
                <td className="px-6 py-4 text-[#333333]">
                  {student.department}
                </td>
                <td className="px-6 py-4">
                  <button
                    type="button"
                    data-modal-toggle="popup-modal"
                    onClick={() => handleStudentDeletionBtn(student)}
                    className="block text-white bg-red-700 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-red-600 dark:hover:bg-red-700 dark:focus:ring-red-800"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {students.length === 0 && (
        <div className="flex flex-row justify-center items-center text-5xl w-full h-[10%] py-[10%]">
          <h1>No Data Available</h1>
        </div>
      )}

      <DeleteUserModal
        title={`Are you sure you want to delete this student with GR/PR No ${studentForDeletion.username}`}
        show={isDeleteModalOpened}
        username={studentForDeletion.username}
        onConfirmationCallback={handleStudentDeleteModalBtn}
        onCloseCallback={() => setDeleteModalOpened(false)}
      />
    </>
  );
};

export default StudentTable;
